// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"7f61eec8","787":"567f44e2"}[chunkId] + ".chunk.js";
};